<template>
  <div class="ani-group-container">
    <!-- <nav class="nav-header">
      <p @click="$router.push({name: 'system-admin-sms-routes'})"
         :class="($route.name === 'system-admin-sms-routes' || $route.name === 'system-admin-add-route-product') ? 'active' : ''">Basic Info</p>
      <p  @click="$router.push({name: 'system-admin-rate-table'})"
         :class="($route.name === 'system-admin-rate-table' || $route.name === 'system-admin-rate-table-add') ? 'active' : ''">Rates and Route</p>
    </nav>-->
    <router-view class="router-container" />
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
};
</script>

<style lang="scss" scoped>
.ani-group-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    padding: 0px 15px 0px 15px;
    display: flex;
    p {
      cursor: pointer;
      height: 100%;
      display: flex;
      align-items: center;
      padding: 0px 5px 0px 5px;
      color: #bdbfd8;
      font-family: "" Helvetica Neue "";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      text-align: center;
      margin-right: 10px;
      margin-bottom: 0;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
  }
  .router-container {
    padding: 0 20px;
  }
}
</style>

